import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import InputCustom from '../../../components/atoms/input/InputCustom'
import { Box } from '@mui/material'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import { toastHelper } from '../../../util/toastHelper'

function WeddingName({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
}) {
	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>Enter a name for your wedding!</h2>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<Box className={styles.formInputs}>
								<InputCustom
									type="text"
									name="kazooName"
									placeholder="Wedding Name"
									value={weddingData.kazooName}
									setDataFunction={setWeddingData}
									data={weddingData}
									required={true}
									// disabled={!save}
									data_cy="weddingName"
								/>
							</Box>
						</div>
					</div>
				</div>
				<ButtonCustom
					size="lg"
					data-cy="wizard-next"
					onClick={() => {
						if (!weddingData.kazooName.trim())
							return toastHelper(
								'Wedding name is required',
								'error'
							)
						handleNext()
					}}
				>
					Next
				</ButtonCustom>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={1} />
				</div>
			</div>
		</NewWedingModal>
	)
}

export default WeddingName
